export default __webpack_public_path__ + "static/media/hht2_home_img_EP7.8b7bf9ea.png";